import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subscription } from 'rxjs';
import { RowDataDb } from 'src/app/model/help';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import * as HelpActions from 'src/app/store/help/help.actions';
import { selectRowModify } from 'src/app/store/help/help.selector';
import { StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	templateUrl: './helper-row.dialog.component.html',
})

export class HelperRowDialogComponent implements OnInit, OnDestroy {
	rowModifySuccess$: Observable<boolean | undefined>;
	rowModifySuccessSub: Subscription | undefined;

	rowForm: FormGroup;
	row: RowDataDb;
	adding = true;

	subsectionId: number;

	types = [
		{ name: 'TEXT', code: 'text' },
		{ name: 'VIDEO', code: 'video' },
		{ name: 'IMAGE', code: 'image' },
	];

	flagImagePath = './assets/images/flags/';
	flagImageFormat = '.svg';

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		if (config.data !== undefined && config.data.subsectionId !== undefined) {
			this.subsectionId = config.data.subsectionId;
		}
		if (config.data !== undefined && config.data.row !== undefined) {
			this.row = config.data.row;
			this.adding = false;
		} else {
			this.row = new RowDataDb();
			this.row.Order = 0;
			this.row.ContentType = 'text';
			this.row.StartSecond = 0;
			this.row.EndSecond = 0;
			this.adding = true;
		}
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		StandardNewValidator.setFirstCompile(true);

		this.onResize();
	}

	buildForm(): void {
		this.rowForm = new FormGroup({
			'ContentType': new FormControl(this.row.ContentType, Validators.required),
			'ContentIt': new FormControl(this.row.ContentIt, Validators.required),
			'ContentEn': new FormControl(this.row.ContentEn),
			'ContentEs': new FormControl(this.row.ContentEs),
			'ContentDe': new FormControl(this.row.ContentDe),
			'ContentFr': new FormControl(this.row.ContentFr),
			'ContentNl': new FormControl(this.row.ContentNl),
			'ContentPl': new FormControl(this.row.ContentPl),
			'ContentRu': new FormControl(this.row.ContentRu),
			'ContentSk': new FormControl(this.row.ContentSk),
			'ContentHu': new FormControl(this.row.ContentHu),
			'ContentPt': new FormControl(this.row.ContentPt),
			'ContentSv': new FormControl(this.row.ContentSv),
			'ContentCs': new FormControl(this.row.ContentCs),
			'StartSecond': new FormControl(this.row.StartSecond, Validators.required),
			'EndSecond': new FormControl(this.row.EndSecond, Validators.required),
		});
	}

	initSelectors(): void {
		this.rowModifySuccess$ = this.store.select(selectRowModify);
	}


	subscribeAll(): void {
		this.rowModifySuccessSub = this.rowModifySuccess$?.subscribe(
			(rowModifySuccess) => {
				if (rowModifySuccess) {
					this.ref.close('success');
				}
			}
		);
	}

	ngOnDestroy(): void {
		this.rowModifySuccessSub?.unsubscribe();
	}

	isRowText(): boolean {
		return this.f.ContentType.value === 'text';
	}

	isRowVideo(): boolean {
		return this.f.ContentType.value === 'video';
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.rowForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.rowForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	getFlagImage(langCode: string): string {
		return this.flagImagePath + langCode + this.flagImageFormat;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		if (this.subsectionId === undefined) {
			this.subsectionId = this.row.SubsectionId;
		}
		this.row = {
			...this.row,
			SubsectionId: this.subsectionId,
			ContentType: this.f.ContentType.value,
			ContentIt: this.f.ContentIt.value,
			ContentEn: this.f.ContentEn.value,
			ContentEs: this.f.ContentEs.value,
			ContentDe: this.f.ContentDe.value,
			ContentFr: this.f.ContentFr.value,
			ContentNl: this.f.ContentNl.value,
			ContentPl: this.f.ContentPl.value,
			ContentRu: this.f.ContentRu.value,
			ContentSk: this.f.ContentSk.value,
			ContentHu: this.f.ContentHu.value,
			ContentPt: this.f.ContentPt.value,
			ContentSv: this.f.ContentSv.value,
			ContentCs: this.f.ContentCs.value,
			StartSecond: this.f.StartSecond.value,
			EndSecond: this.f.EndSecond.value,
		};

		if (this.row.Id) {
			this.store.dispatch(HelpActions.editHelpRow({ row: this.row }));
		} else {
			this.store.dispatch(HelpActions.addHelpRow({ row: this.row }));
		}
	}

	get f(): any {
		return this.rowForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	newShowErrors(type: HelperRowDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	showErrorRequiredMessage(type: HelperRowDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-20rem');
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}
}
